import { Schema } from 'prosemirror-model';
/**
 * Base node specs without DOM-specific methods (parseDOM/toDOM).
 * Frontend extends these with DOM handling.
 */
export const nodeSpecs = {
    doc: {
        content: 'block+',
    },
    paragraph: {
        content: 'inline*',
        group: 'block',
    },
    heading: {
        attrs: { level: { default: 1 } },
        content: 'text*',
        group: 'block',
        defining: true,
        marks: '',
    },
    task: {
        attrs: {
            done: { default: false },
            active: { default: false },
            id: { default: '' },
        },
        content: 'inline*',
        group: 'block',
        defining: true,
        isolating: true,
    },
    text: {
        group: 'inline',
    },
    numberNode: {
        inline: true,
        group: 'inline',
        atom: true,
        selectable: true,
        draggable: false,
        attrs: {
            base: { default: 0 },
        },
    },
    bulletList: {
        content: 'listItem+',
        group: 'block',
    },
    orderedList: {
        content: 'listItem+',
        group: 'block',
        attrs: {
            order: { default: 1 },
        },
    },
    listItem: {
        content: 'paragraph block*',
        defining: true,
    },
    table: {
        content: 'table_row+',
        group: 'block',
        tableRole: 'table',
        isolating: true,
    },
    table_row: {
        content: '(table_cell | table_header)+',
        tableRole: 'row',
    },
    table_cell: {
        content: 'block+',
        attrs: {
            colspan: { default: 1 },
            rowspan: { default: 1 },
            colwidth: { default: null },
        },
        tableRole: 'cell',
        isolating: true,
    },
    table_header: {
        content: 'block+',
        attrs: {
            colspan: { default: 1 },
            rowspan: { default: 1 },
            colwidth: { default: null },
        },
        tableRole: 'header_cell',
        isolating: true,
    },
};
export const markSpecs = {
    multiplier: {},
    strong: {},
    em: {},
    tag: {},
};
export const schema = new Schema({ nodes: nodeSpecs, marks: markSpecs });
//# sourceMappingURL=schema.js.map